import { whiteColor, hexToRgb, blackColors } from 'assets/jss/material-dashboard-pro-react';

const customDialogStyle = (theme) => ({
	dialog: {
		'& .MuiPaper-root': {
			marginLeft: '10px',
			marginRight: '10px',
			width: '400px',
			maxWidth: '100%',
			padding: '32px 32px 32px 48px',
			display: 'flex',
			alignItems: 'flex-start',
			'& img': {
				marginBottom: '22px',
			},
		},
	},
	buttonsWrapper: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: '72px',
		width: '100%',
		'& button:first-of-type': {
			marginRight: '8px',
		},
	},
	dialogBody: {
		[theme.browser.IE]: {
			maxWidth: '100%',
		},
	},
	loadingWrapper: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		background: `rgba(${hexToRgb(whiteColor)}, 0.9)`,
	},
	dialogCloseButton: {
		background: 'transparent',
		border: 'none',
		display: 'flex',
		padding: 0,
		alignItems: 'center',
		marginBottom: '7px',
		cursor: 'pointer',
		marginLeft: 'auto',
		marginRight: 0,
		'& svg': {
			fontSize: '24px',
			color: blackColors[3],
		},
	},
});

export default customDialogStyle;
